/**
 * Application Version Tracking
 * 
 * VERSION: Major.Minor.Patch format
 * FIX_NUMBER: Incremental fix counter for bug fixes
 * 
 * Update these values before each deployment
 */

export const VERSION = "1.0.1";
export const FIX_NUMBER = 14;
export const VERSION_FULL = `v${VERSION} (Fix #${FIX_NUMBER})`;

/**
 * Get version info for display
 */
export function getVersionInfo() {
  return {
    version: VERSION,
    fixNumber: FIX_NUMBER,
    versionFull: VERSION_FULL,
    buildDate: new Date().toISOString(),
  };
}
